/**
 * Greenargen CRO — cart & buy-box fixes (2026-06-06)
 * Scope: cart shipping clarity, cart trust line, checkout CTA wrapper, subscription consent.
 * Does NOT inject guarantee on Shogun PDP (trust row already live). Cart-only guarantee removed.
 */
(function () {
  "use strict";

  var TRUST_LINE = "Secure checkout · No subscription required · Free U.S. shipping";
  var SHIPPING_US = "U.S. Shipping: FREE";
  var SHIPPING_INTL = "International shipping calculated at checkout";
  var SHIPPING_TAX = "Taxes calculated at checkout";

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getCountry() {
    if (window.Shopify && Shopify.country) return Shopify.country;
    var accel = document.querySelector("shopify-accelerated-checkout");
    if (accel && accel.getAttribute("buyer-country")) {
      return accel.getAttribute("buyer-country");
    }
    return "US";
  }

  function walkRoots(node, cb) {
    if (!node) return;
    cb(node);
    node.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) walkRoots(el.shadowRoot, cb);
    });
  }

  function isSubscriptionSelected() {
    var selected = false;

    walkRoots(document, function (root) {
      if (selected) return;
      var sub = root.querySelector(
        '.rc-purchase-option__selector_subscription[aria-checked="true"],' +
          '[part*="subscription"][aria-checked="true"],' +
          '.rc-purchase-option--subscription--selected,' +
          '[data-purchase-option="subscription"][aria-checked="true"]'
      );
      if (sub) selected = true;
    });

    var sellingPlan = document.querySelector('input[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value && sellingPlan.value !== "") {
      selected = true;
    }

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var fd = new FormData(form);
      var plan = fd.get("selling_plan");
      if (plan) selected = true;
    }

    return selected;
  }

  function manageSubscriptionConsent() {
    var consent = document.getElementById("shopify-buyer-consent");
    if (!consent) return;

    var show = isSubscriptionSelected();
    if (show) {
      consent.id = "shopify-buyer-consent";
      consent.classList.remove("hidden");
      consent.removeAttribute("aria-hidden");
      consent.style.display = "";
    } else {
      consent.id = "ga-cro-consent-suppressed";
      consent.classList.add("hidden");
      consent.setAttribute("aria-hidden", "true");
      consent.setAttribute("data-ga-cro-suppressed", "1");
      consent.style.display = "none";
    }
  }

  function enhanceProductBuyBox() {
    manageSubscriptionConsent();
  }

  function replaceCartShipping() {
    var shipping = document.querySelector(".cart__shipping");
    if (!shipping || shipping.dataset.gaCroDone) return;

    shipping.dataset.gaCroDone = "1";
    shipping.classList.add("cart__shipping--original-hidden");

    var wrap = document.createElement("div");
    wrap.className = "ga-cro-shipping-messaging";
    wrap.setAttribute("data-ga-cro", "shipping");

    var country = getCountry();
    var usLine = document.createElement("div");
    usLine.className = "ga-cro-shipping-us";
    usLine.textContent = country === "US" ? "✓ " + SHIPPING_US : SHIPPING_US;

    var intlLine = document.createElement("div");
    intlLine.className = "ga-cro-shipping-intl";
    intlLine.textContent = SHIPPING_INTL;

    var taxLine = document.createElement("div");
    taxLine.className = "ga-cro-shipping-tax";
    taxLine.textContent = SHIPPING_TAX;

    wrap.appendChild(usLine);
    wrap.appendChild(intlLine);
    wrap.appendChild(taxLine);

    shipping.insertAdjacentElement("afterend", wrap);
  }

  function enhanceCartCheckout() {
    var checkoutBtn =
      document.getElementById("CheckOut") ||
      document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn || checkoutBtn.dataset.gaCroDone) return;

    checkoutBtn.dataset.gaCroDone = "1";

    var parent = checkoutBtn.parentElement;
    if (!parent) return;

    if (!parent.classList.contains("ga-cro-checkout-wrap")) {
      var wrap = document.createElement("div");
      wrap.className = "ga-cro-checkout-wrap";
      wrap.setAttribute("data-ga-cro", "checkout-wrap");
      parent.insertBefore(wrap, checkoutBtn);
      wrap.appendChild(checkoutBtn);
      parent = wrap;
    }

    if (!parent.querySelector(".ga-cro-trust-line")) {
      var trust = document.createElement("p");
      trust.className = "ga-cro-trust-line";
      trust.setAttribute("data-ga-cro", "trust-line");
      trust.textContent = TRUST_LINE;
      parent.insertBefore(trust, checkoutBtn);
    }

    checkoutBtn.classList.remove("button--outline");
    checkoutBtn.classList.add("button--solid");
    labelCheckout(checkoutBtn);
    demoteContinue();
  }

  function labelCheckout(checkoutBtn) {
    window
      .fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.total_price) return;
        var label = "Check out · $" + (cart.total_price / 100).toFixed(2);
        if (checkoutBtn.tagName === "INPUT") checkoutBtn.value = label;
        else checkoutBtn.textContent = label;
      })
      .catch(function () {});
  }

  function demoteContinue() {
    document.querySelectorAll("a, button").forEach(function (el) {
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (/^continue shopping$/i.test(t)) el.classList.add("ga-cro-continue");
    });
  }

  function enhanceCart() {
    document.body.classList.add("ga-cro-cart");
    replaceCartShipping();
    enhanceCartCheckout();
    demoteContinue();
  }

  function run() {
    enhanceProductBuyBox();
    if (document.querySelector(".cart__form, #cart, .cart-holder")) {
      enhanceCart();
    }
  }

  function observe() {
    manageSubscriptionConsent();

    var queued = false;
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        manageSubscriptionConsent();
        run();
      }, 200);
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener("click", function () {
      setTimeout(manageSubscriptionConsent, 50);
      setTimeout(manageSubscriptionConsent, 300);
    });
    document.addEventListener("change", function () {
      setTimeout(manageSubscriptionConsent, 50);
    });

    setInterval(manageSubscriptionConsent, 800);
  }

  onReady(function () {
    run();
    observe();
    setTimeout(run, 500);
    setTimeout(run, 1500);
    setTimeout(run, 3000);
  });
})();
